<template>
  <div  style="height: 100%">  
    <b-row>
      <b-col :md="12" style="padding:0;height:65px">
        <sw-header>
        </sw-header> 
      </b-col>
      <b-col :md="12" style="padding:0;">
        <b-row>
            <b-col style="padding:0; height: 100%;flex-basis:200px;flex-grow: 0;">
              <sw-aside v-if="aside">
              </sw-aside> 
            </b-col>
            <b-col style="padding:0; height: 100%;">     
              <div class="body-sw">     
                <div  v-show="loading" class="loading-capa">
                  <div class="i-wrapper loading-black"><i class="i-spinner i-spinner--light loading-i"></i></div>          
                </div>        
                <div class="blocksave" v-show="saveConfig.capa"></div>
                <router-view>
                </router-view> 
              </div>  
            </b-col>
        </b-row>
      </b-col>     
    </b-row>          
    <sw-notification></sw-notification>        
  </div>
</template>

<script>
import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

import { mapState, mapActions } from "vuex";
import SwAside  from './aside.vue';
import SwHeader  from './header.vue';

export default {
  name: "master-layout",  
  data () {
    return {
      aside: true,
      nose: null
    }
  },
  components: {
    SwAside,
    SwHeader    
  },
  mounted () {
    /*window.Echo = new Echo({
      broadcaster: 'pusher',
      key: 'd76e4670569a914f43bb',
      wsHost: window.location.hostname,
      wsPort: 6001,
      disableStats: true
    })

    window.Echo.channel('home').listen('StockDisponible', (resp) => {      
      console.log(resp)
    })*/
  },
  async created () {  
    await this.getDataList({route: 'get_lists', data: 'list'})
    await this.getIdb();        
    let searchsKeys = Object.keys(this.lists)
    let newSwSearchs= {}
    for (let i = 0; i < searchsKeys.length; i++) {

      newSwSearchs[searchsKeys[i]] = '';      
    }
    await this.updateCrud({state: 'swSearchs', data: newSwSearchs})
  },
  computed: { 
    ...mapState({
      loading: state => state.globalStore.saveConfig.loading,
    })   
  },
  methods: {
    ...mapActions({      
        getDataList:  'crudStore/getDataList',         
    })
  }
};
</script>
<style>
.bv-no-focus-ring {
    width: 100%;
}
.option-btn {
  cursor:pointer
}
.body-sw{
  padding: 50px
}
.card-body{
  padding: 10px 
}
.title-form{
   border-bottom: 1px solid rgba(85, 85, 85, .6); 
   padding-bottom:10px;
   margin:30px 0 10px;
   color:#555
}
.form-control{
  
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
:focus {
    outline: none;
}
.box-effect.linear {
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
}
.is-invalid{
  background-image: none !important
}
.btn.disabled {
  cursor: no-drop;
}
.col-form-label{  
    padding-bottom: 3px !important;
    color: rgb(85, 85, 85);
}
.header-card{
   text-align: center;
   font-weight: 600;
   font-size: 20px;
   
 }
.row{
  margin-left: 0;
  margin-right: 0;
}
.blocksave{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0px;
  background: rgba(255,255,255,.7);
  z-index: 1000;
}
.modalsave{
  position: absolute;
  width: 100%;
  height: calc(100% + 65px);
  top: -64px;;
  left: 0px;
  background: rgba(255,255,255,.7);
  z-index: 1046;
  border-radius: 5px;
}
.loading-btn
{
  position: relative;
  color: transparent !important;
}
.loading-btn-active
{
    position: absolute;
    right: 0;
    z-index: 17;
}
.loading-btn:after
{
  
  border-left-color: #fff !important;
  border-bottom-color: #fff !important;
  animation: spin-around 500ms infinite linear;
  border: 2px solid #888888;
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 16px;
  width: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -8px;
  margin-top: -8px;
}
.border-edit{
  border-color: rgba(0,123,255,0.5) 
}
.opacity-save{
  opacity: 0.7
}
.btn:focus, .btn.focus{
 box-shadow:inherit
}
.dropdown-item.active, .dropdown-item:active{
  background-color: #563d7c;
}
.text-inactive{
  color: #E66B32 !important
}
.bg-sw-inactive{
  background: #737575 !important
}
.bg-sw-nuevo{
  background: #60438A;
}
.sw-md{
  width: 800px !important
}
.btn-outline-modal{  
    color: #8C63C9 !important;
    border-color: #8C63C9 !important;
}
.btn-outline-modal:hover{  
    color: white !important;
    background-color: #60438A !important;
}
.popover.b-popover{
  max-width: 800px
}
.custom-checkbox label{
  justify-content: initial !important;
}
.title-form.subtitle-form{
  font-size:18px;
}
@-webkit-keyframes spin-around {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg); }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg); } }

@keyframes spin-around {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg); }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg); } }
</style>
